import type { SignalData } from '../api/client'

/**
 * Display-level fund return in percent: the synth NAV return with the live
 * FVA gap correction folded in (live since 2026-07-14; fund-generic since
 * 2026-07-27).
 *
 * The engine subtracts fva_correction from the signal AFTER synth-NAV
 * selection (signal = synth_nav_return_gbp − fva_correction), so any display
 * built on the raw synth return overstates the expected NAV move on
 * FVA-triggered days — the 2026-07-14 defect where the BGA sparkline showed
 * +2.42% while the engine acted on +1.36%.
 *
 * No-op for fva_mode off/null and for degraded-inert payloads (correction 0).
 */
export function displayFundReturnPct(signal: SignalData | null | undefined): number | null {
  const synth = signal?.synth_nav_return_gbp
  if (synth == null || signal == null) return null
  const corr = signal.fva_mode === 'gap_correct' && signal.fva_correction != null
    ? signal.fva_correction : 0
  return (synth - corr) * 100
}
